import { render, staticRenderFns } from "./CaresheetPage.vue?vue&type=template&id=0588a3ac&"
import script from "./CaresheetPage.vue?vue&type=script&lang=js&"
export * from "./CaresheetPage.vue?vue&type=script&lang=js&"
import style0 from "./CaresheetPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports